import { createContext } from 'react';
import type { UserConfigContextValue } from '../types/userConfigContext';

export const UserConfigContext = createContext<UserConfigContextValue | null>(
  null,
);
